import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { Modal } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  name: "design-top",
  i18n: require('../design_i18n'),
  data: function data() {
    return {
      title: "",
      // 活动标题

      current_pipeline: "",
      // 当前选择的渠道
      current_lang: "",
      // 当前选择的语言
      current_platform: "m",
      // 当前选择的端口
      curPage: 'design',
      // 当前页面
      select_options: {
        // 所有渠道列表
        pipelines: [{
          name: "DEMO",
          code: "ZF"
        }],
        // 所有语言列表
        langs: [{
          name: "简体中文",
          code: "cn"
        }, {
          name: "英文",
          code: "en"
        }],
        // 所有设备终端列表
        platforms: [{
          name: "PC端",
          code: "pc",
          icon: "li-icon-pc"
        }, {
          name: "移动端",
          code: "m",
          icon: "li-icon-m"
        }]
      },
      // 下拉选项的公共样式配置
      selectStyle: {
        "text-align": "center"
      }
    };
  },
  // watch: {
  //     '$route': function(){
  //         this.current_platform = this.$route.query.platform || "m";

  //     }
  // },

  computed: _objectSpread(_objectSpread({}, mapState({
    formEdited: function formEdited(state) {
      return state.design.formEdited;
    },
    components: function components(state) {
      return state.design.components;
    }
  })), {}, {
    platform: function platform() {
      return this.$store.getters['design/getPlatform'];
    },
    // scale: {
    //   get() {
    //     return this.$store.state.design.scale;
    //   },
    //   set(val) {
    //     this.$store.commit("design/set_scale", val);
    //   },
    // },
    previewLink: function previewLink() {
      if (this.platform == 'pc') {
        return process.env.VUE_APP_API_PC_PREVIEW;
      } else {
        return process.env.VUE_APP_API_APP_PREVIEW;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;
    console.log('this.$route', this.$route);
    this.$watch('components', function (val, old) {
      _this.$store.dispatch('design/setFormEdited');
    }, {
      deep: true
    });
  },
  methods: {
    handlePageChange: function handlePageChange(val) {
      if (val === 'design') return;
      this.$router.push({
        path: '/designCategory'
      });
    },
    handlePreviewClick: function handlePreviewClick() {
      this.$router.push({
        path: '/design/preview'
      });
    },
    /**
     * 渠道改变
     * @param {String} code 渠道编码
     * **/
    handlePipelineChange: function handlePipelineChange(code) {
      this.current_pipeline = code;
    },
    /**
     * 语言改变
     * @param {String} code 语言编码
     * **/
    handleLangChange: function handleLangChange(code) {
      this.current_lang = code;
    },
    /**
     * 端口改变
     * @param {String} code 设备端编码 pc/wap
     * **/
    handleClientChange: function handleClientChange(code) {
      if (this.platform == code) return;
      this.$store.dispatch("design/setPlatform", code);

      //   this.$router.push({ path: "/design", query: { platform: code } });

      // this.$confirm({
      //   title: "您编辑的内容还没有保存, 是否切换?",
      //   onOk: () => {
      //       this.$store.dispatch("design/setPlatform", code);
      //       // this.$router.push({ path: "/design", query: { platform: code } });
      //   },
      // });
    },
    /**
     * 页面保存
     */
    handle_page_save: function handle_page_save() {
      var _this2 = this;
      if (!this.formEdited) return;
      this.$store.dispatch("design/page_save").then(function (res) {
        _this2.$message.success(_this2.$t('stateDesign.saveSuccess'));
      }).catch(function (res) {
        console.log('res', res);
        if (res != 'notip') {
          _this2.$message.error(_this2.$t('stateDesign.saveError'));
        }
      });
    },
    /**
     * 发布页面
     */
    handle_page_release: function handle_page_release() {
      var that = this;
      Modal.confirm({
        title: this.$t('header.surepublish'),
        onOk: function onOk() {
          that.$store.dispatch('design/page_publish');
        }
      });
    }
  }
};